import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const initialForm = {
  prenume: "",
  nume: "",
  cnp: "",
  tara: "România",
  judet: "",
  oras: "",
  email: "",
  telefon: "",
  membru: false,
  voluntar: false,
  membruVoluntar: false,
  timestamp: "",
};

const AddPersonModal = ({ show, onHide, onSave, initialData }) => {
  const [form, setForm] = useState(initialForm);

  // Resetare formular la montare/deschidere
  useEffect(() => {
    if (initialData) {
      setForm(initialData);
    } else {
      setForm(initialForm);
    }
  }, [initialData, show]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = () => {
    onSave(form);
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          {initialData ? "Editează Persoană" : "Adaugă Persoană"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <div className="row">
            {["prenume", "nume", "cnp", "judet", "oras", "email", "telefon"].map(
              (field) => (
                <div className="col-md-6 mb-3" key={field}>
                  <Form.Label>
                    {field.charAt(0).toUpperCase() + field.slice(1)}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name={field}
                    value={form[field]}
                    onChange={handleChange}
                  />
                </div>
              )
            )}

            <div className="col-md-6 mb-3">
              <Form.Label>Țara</Form.Label>
              <Form.Control
                name="tara"
                value={form.tara}
                onChange={handleChange}
                disabled
              />
            </div>

            <div className="col-md-12">
              <div className="d-flex gap-4">
                {["membru", "voluntar", "membruVoluntar"].map((field) => (
                  <Form.Check
                    key={field}
                    type="checkbox"
                    id={field}
                    label={field
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (str) => str.toUpperCase())}
                    name={field}
                    checked={form[field]}
                    onChange={handleChange}
                  />
                ))}
              </div>
            </div>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Închide
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Salvează
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddPersonModal;
